import { AbstractControl, FormGroup } from '@angular/forms';
import { UnitsGridColumn } from './units-grid-input.models';

export interface UnitsGridPasteMatrixArgs {
  readonly matrix: readonly (readonly string[])[];
  readonly startRowIndex: number;
  readonly startColumnIndex: number;
  readonly columns: readonly UnitsGridColumn[];
  readonly ensureRow: (rowIndex: number) => FormGroup | null;
  readonly isEditable: (column: UnitsGridColumn) => boolean;
  readonly normalizeValue: (value: string, column: UnitsGridColumn) => string | number | null | undefined;
}

export function isMatrixPasteText(text: string): boolean {
  return text.includes('\n') || text.includes('\t');
}

export function applyUnitsGridPasteMatrix(args: UnitsGridPasteMatrixArgs): number {
  let changedCells = 0;

  args.matrix.forEach((rowValues, rowOffset) => {
    const rowIndex = args.startRowIndex + rowOffset;
    const row = args.ensureRow(rowIndex);
    if (!row) {
      return;
    }

    rowValues.forEach((rawValue, colOffset) => {
      const columnIndex = args.startColumnIndex + colOffset;
      const column = args.columns[columnIndex];
      if (!column || !args.isEditable(column)) {
        return;
      }

      const control = row.get(column.field) as AbstractControl | null;
      if (!control || control.disabled) {
        return;
      }

      const normalizedValue = args.normalizeValue(rawValue, column);
      if (normalizedValue === undefined) {
        return;
      }

      control.setValue(normalizedValue);
      control.markAsDirty();
      control.markAsTouched();
      changedCells += 1;
    });
  });

  return changedCells;
}
